import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import { getPageName } from '../../utils/pageName';
import {
  withFeatures,
  WithFeaturesPropsType,
} from '../../features/withFeatures';

import './new_way.scss';

type Props = WithFeaturesPropsType;

export class RawNewWayContent extends React.Component<Props> {
  sourcePage: string = getPageName();

  askDemo = () => {
    doctrineAnalytics('AskDemoClicked', { source: 'mainCTA' });
  };

  render() {
    const { sourcePage } = this;
    const { isFeatureEnabled } = this.props;

    return (
      <div className="new-way__content__container">
        <h1 className="new-way__content__title">
          <FormattedMessage id="app.home.newway.title" />
        </h1>
        <div className="new-way__content__subtitle">
          <p>
            <FormattedMessage id="app.home.newway.summary" />
          </p>
        </div>
        <div className="new-way__content__cta-group">
          {isFeatureEnabled('public-home/demo') && (
            <Hyperlink
              data-test-id="new-way-demo"
              target="_blank"
              href="/demo"
              source="home_public"
              className="new-way__content__cta-group__button button  hollow secondary large"
            >
              <FormattedMessage id="app.home.newway.demoAction" />
            </Hyperlink>
          )}
          <Hyperlink
            className="new-way__content__cta-group__button button large brand"
            href={buildUrlWithParameters('/inscription', {
              source: 'main_cta',
              sourcePage,
            })}
          >
            <FormattedMessage id="app.home.newway.signupAction" />
          </Hyperlink>
        </div>
      </div>
    );
  }
}

export const NewWayContent = withFeatures('all')(RawNewWayContent);
